import React from 'react'
import Plx from 'react-plx'

import BackgroundColorChanger from '@components/layout/background_color_changer'

const StandardLayout = ({ children }) => (
  <div className="standardLayout">
    <BackgroundColorChanger>
      {addChildRef => (
        <React.Fragment>
          <Plx
            className="page__bgPattern"
            parallaxData={[
              {
                start: 0,
                duration: 500,
                name: 'background',
                properties: [
                  {
                    startValue: 1,
                    endValue: 0,
                    property: 'opacity',
                  },
                ],
              },
            ]}
          >
            <div className="page__bgPatternImage" />
          </Plx>

          <Plx
            className="page__bgHeader"
            parallaxData={[
              {
                start: 0,
                duration: 500,
                name: 'background',
                properties: [
                  {
                    startValue: 0,
                    endValue: -150,
                    property: 'translateY',
                  },
                ],
              },
              {
                start: 50,
                duration: 100,
                properties: [
                  {
                    startValue: 1,
                    endValue: 0.92,
                    property: 'scale',
                  },
                ],
              },
              {
                start: 450,
                duration: 2,
                properties: [
                  {
                    startValue: 1,
                    endValue: 0,
                    property: 'opacity',
                  },
                ],
              },
            ]}
          >
            <div className="page__bgContent">
              {React.cloneElement(children[0], { ref: addChildRef })}
            </div>
          </Plx>

          <Plx
            className="page__foreground"
            parallaxData={[
              {
                start: 500,
                duration: 500,
                name: 'background',
                properties: [
                  {
                    startValue: 'rgba(255,255,255,1)',
                    endValue: 'rgba(255,255,255,0)',
                    property: 'backgroundColor',
                  },
                ],
              },
            ]}
          >
            {children.slice(1).map(child => React.cloneElement(child, { ref: addChildRef }))}
          </Plx>
        </React.Fragment>
      )}
    </BackgroundColorChanger>
  </div>
)

export default StandardLayout
